import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card text-foreground py-8 border-t border-border mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h5 className="text-lg font-semibold mb-3 text-primary">Clipoid</h5>
            <p className="text-sm text-muted-foreground">
              Effortlessly create engaging video clips.
            </p>
          </div>
          <div>
            <h5 className="text-lg font-semibold mb-3">Legal</h5>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h5 className="text-lg font-semibold mb-3">Quick Links</h5>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/subscription" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Subscription
                </Link>
              </li>
              <li>
                <Link to="/clips" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  My Clips
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h5 className="text-lg font-semibold mb-3">Contact</h5>
            {/* Add social media links or contact info here if needed */}
            <p className="text-sm text-muted-foreground">
              contact@clipoid.com
            </p>
          </div>
        </div>
        <div className="border-t border-border pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            &copy; {currentYear} Clipoid. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground/80 mt-1">
            Real Tools for Real Players. Made with ❤️ and AI.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;